export const pluralize = (count: number, one: string, few: string, many: string, isShowCount = true): string => {
    const lastDigit = count % 10;
    const lastTwoDigits = count % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return isShowCount ? `${count} ${many}` : many;
    }

    if (lastDigit === 1) {
        return isShowCount ? `${count} ${one}` : one;
    }

    if (lastDigit >= 2 && lastDigit <= 4) {
        return isShowCount ? `${count} ${few}` : few;
    }

    return isShowCount ? `${count} ${many}` : many;
};
